!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("@material-ui/core/Box")) : "function" == typeof define && define.amd ? define(["exports", "react", "@material-ui/core/Box"], t) : t((e = e || self).pane = {}, e.React, e.Box);
}(this, function (e, t, r) {
  "use strict";

  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t, r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;

  var _l = function l() {
    return (_l = Object.assign || function (e) {
      for (var t, r = 1, l = arguments.length; r < l; r++) for (var n in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);

      return e;
    }).apply(this, arguments);
  };

  function n(e, t) {
    var r = {};

    for (var l in e) Object.prototype.hasOwnProperty.call(e, l) && t.indexOf(l) < 0 && (r[l] = e[l]);

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var n = 0;

      for (l = Object.getOwnPropertySymbols(e); n < l.length; n++) t.indexOf(l[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[n]) && (r[l[n]] = e[l[n]]);
    }

    return r;
  }

  var o = t.forwardRef(function (e, r) {
    var o = e.children,
        a = e.style,
        i = n(e, ["children", "style"]);
    return t.createElement("div", _l({
      ref: r
    }, i, {
      style: _l(_l({}, a), {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden"
      })
    }), o);
  });
  e.Pane = o, e.PaneFooter = function (e) {
    var l = e.children;
    return t.createElement(r, {
      className: "PaneFooter",
      display: "flex",
      flex: "0 0 auto",
      width: 1
    }, l);
  }, e.PaneHeader = function (e) {
    var l = e.children;
    return t.createElement(r, {
      className: "PaneHeader",
      display: "flex",
      flex: "0 0 auto",
      width: 1
    }, l);
  }, e.PaneScrollable = function (e) {
    var r = e.children,
        o = e.style,
        a = e.disableScroll,
        i = n(e, ["children", "style", "disableScroll"]);
    return t.createElement("div", _l({}, i, {
      className: "PaneScrollableVertical",
      style: a ? o : _l(_l({}, o), {
        contain: "strict",
        flex: "1 1 auto",
        position: "relative",
        display: "block",
        minHeight: "1px",
        overflowX: "hidden",
        overflowY: "auto",
        willChange: "transform"
      })
    }), t.createElement("div", {
      className: "PaneScrollableHorizontal",
      style: a ? o : _l(_l({}, o), {
        minHeight: "100%",
        display: "block",
        overflowX: "auto",
        overflowY: "hidden",
        minWidth: "1px"
      })
    }, r));
  }, e.PaneWrapper = function (e) {
    var l = e.children;
    return t.createElement(r, {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      height: 1,
      position: "relative"
    }, l);
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});